import {
    createAsyncThunk,
    createSlice,
} from "@reduxjs/toolkit";

import {
    employeeAdvanceApi,
    employeeLeaveApi,
    employeeLeaveTypeApi,
} from "../../components/dashboard/components/AdminComponent/EmployeeManagement/utils/employeeApi";


const initialState = {

    records:
        [],

    leaveTypes:
        [],

    balances:
        [],

    pagination: {

        page:
            1,

        limit:
            10,

        totalRecords:
            0,

        totalPages:
            1,

    },

    loading:
        false,

    actionLoading:
        false,

    error:
        null,

};


export const fetchEmployeeLeaves =
    createAsyncThunk(
        "employeeLeave/list",

        async (
            payload,
            {
                rejectWithValue,
            }
        ) => {

            try {

                const response =
                    await employeeLeaveApi
                        .getList(
                            payload
                        );


                if (
                    response?.status !==
                    "success"
                ) {

                    return rejectWithValue(
                        response?.message ||
                        "Unable to load employee leaves."
                    );

                }


                return {

                    records:
                        response?.data ||
                        [],

                    pagination:
                        response?.pagination ||
                        {},

                };

            } catch (
                error
            ) {

                return rejectWithValue(
                    error?.response?.data?.message ||
                    error?.message ||
                    "Unable to load employee leaves."
                );

            }

        }
    );


export const fetchEmployeeLeaveTypes =
    createAsyncThunk(
        "employeeLeave/types",

        async (
            _,
            {
                rejectWithValue,
            }
        ) => {

            try {

                const response =
                    await employeeLeaveTypeApi
                        .getList();


                if (
                    response?.status !==
                    "success"
                ) {

                    return rejectWithValue(
                        response?.message ||
                        "Unable to load leave types."
                    );

                }


                return response?.data ||
                    [];

            } catch (
                error
            ) {

                return rejectWithValue(
                    error?.response?.data?.message ||
                    error?.message ||
                    "Unable to load leave types."
                );

            }

        }
    );


const employeeLeaveSlice =
    createSlice({

        name:
            "employeeLeave",

        initialState,

        reducers: {

            clearLeaveError:
                (
                    state
                ) => {

                    state.error =
                        null;

                },

        },

        extraReducers:
            (
                builder
            ) => {

                builder

                    .addCase(
                        fetchEmployeeLeaves
                            .pending,
                        (
                            state
                        ) => {

                            state.loading =
                                true;

                            state.error =
                                null;

                        }
                    )

                    .addCase(
                        fetchEmployeeLeaves
                            .fulfilled,
                        (
                            state,
                            action
                        ) => {

                            state.loading =
                                false;

                            state.records =
                                action
                                    .payload
                                    ?.records ||
                                [];

                            state.pagination = {

                                ...state.pagination,

                                ...(
                                    action
                                        .payload
                                        ?.pagination ||
                                    {}
                                ),

                            };

                        }
                    )

                    .addCase(
                        fetchEmployeeLeaves
                            .rejected,
                        (
                            state,
                            action
                        ) => {

                            state.loading =
                                false;

                            state.error =
                                action.payload;

                        }
                    );


                builder
                    .addCase(
                        fetchEmployeeLeaveTypes
                            .fulfilled,
                        (
                            state,
                            action
                        ) => {

                            state.leaveTypes =
                                Array.isArray(
                                    action.payload
                                )
                                    ?
                                    action.payload
                                    :
                                    [];

                        }
                    );

            },

    });


export const {
    clearLeaveError,
} =
    employeeLeaveSlice.actions;


export default employeeLeaveSlice.reducer;